<header></header>

<div class="d-flex page-wrapper h-100">
    <div class="d-flex box flex-grow-1 flex-column justify-content-center align-items-center px-2">
        <h1>Access Denied</h1>
        <h4>It appears you need an additional level of support.</h4>
        <h4>
            Feel free to reach out to us at
            <a href="mailto:dwtrefunds@sprintax.com">dwtrefunds&#64;sprintax.com</a>
        </h4>
    </div>
</div>
